namespace Upgrades {
    let protoHash: { [key: string]: MobDict } = {
        'machineGun2': {
            name: DictNames.machineGun,
            health: '900 + 2d100',
            armor: '9',
            movementSpeed: '0',
            reloadTimeout: '30',
            attack: '2d10',
            damage: '1d20+3',
            boomRadius: '-1',
            price: '-1000',
            level: 2,

        },
        'machineGun3': {
            name: DictNames.machineGun,
            health: '900 + 2d100',
            armor: '9',
            movementSpeed: '0',
            reloadTimeout: '20',
            attack: '2d10+1',
            damage: '1d20+3',
            boomRadius: '-1',
            price: '-2000',
            level: 3,

        },
        'mortar2': {
            name: DictNames.mortar,
            health: '900 + 2d100',
            armor: '9',
            movementSpeed: '0',
            reloadTimeout: '150',
            attack: 'd20',
            damage: '25',
            boomRadius: '100',
            price: '-3000',
            level: 2,
        },
        'mortar3': {
            name: DictNames.mortar,
            health: '900 + 2d100',
            armor: '9',
            movementSpeed: '0',
            reloadTimeout: '100',
            attack: 'd20',
            damage: '25',
            boomRadius: '100',
            price: '-3000',
            level: 3,
        }

    };
    export function getUpgradeDict(proto: MobDict): MobDict {
        let key = proto.name + (proto.level + 1);
        let result = protoHash[key];
        if (!result) {
            result = genNextProto(proto);
            protoHash[key] = result;
        }
        return result;

    }

    function genNextProto(proto: MobDict): MobDict {
        let newProto = cloneProto(proto);
        newProto.price = ((parseInt(proto.price) * 1.5) | 0) + '';
        if (newProto.name == DictNames.defence) {
            newProto.health += '*1.1';
        }
        newProto.damage += '*1.2';
        newProto.level = proto.level + 1;
        return newProto;
    }

    function cloneProto(proto: MobDict): MobDict {
        let res: any = new MobDict();
        for (let key in proto) {
            res[key] = (proto as any)[key];
        }
        return res as MobDict;
    }

}